import React from "react";
import styled from "styled-components";
// import { Link } from "react-router-dom";
import { Checkbox } from "antd";
import * as R from "ramda";
import { useTranslation } from "react-i18next";

import * as gtag from "../../../../../lib/gtag";

import { Title, Container, StyledCheckbox } from "./FilterComponents";

const NoFilters = styled.span`
  font-size: 12px;
  line-height: 17px;
  color: #9ca8b1;
  margin-bottom: 12px;
`;

const StrictFilters = ({
  // link,
  setStrictFilters,
  options,
  value = [],
  loading
}) => {
  const { t } = useTranslation(["opportunity"]);

  // const onCheckAllChange = e => {
  //   const checked = e.target.checked;

  //   setStrictFilters(checked ? R.pluck("value", options) : []);
  // };

  return (
    <details open={!R.isEmpty(value)}>
      <Title>
        <h4>{t("opportunity:candidates.languageFilters.title")}</h4>
      </Title>
      <Container data-test="strict-filters-container">
        {Boolean(options.length) ? (
          <>
            {/* <StyledCheckbox
            onChange={onCheckAllChange}
            indeterminate={!!value.length && value.length < options.length}
            checked={value.length === options.length}
            disabled={loading}
            style={{ fontWeight: "bold" }}
          >
            {t(
              `opportunity:candidates.strictFilters.${
                value.length === options.length ? "deselectAll" : "selectAll"
              }`
            )}
          </StyledCheckbox> */}
            <Checkbox.Group
              value={value}
              onChange={e => {
                setStrictFilters(e);
                gtag.event({
                  category: "VacancyCandidates",
                  action: `filterExcluding`
                });
              }}
              disabled={loading}
            >
              {options.map(({ value, label }) => (
                <StyledCheckbox
                  key={value}
                  data-test={`checkbox-strict-filters-${value}`}
                  value={value}
                >
                  {label}
                </StyledCheckbox>
              ))}
            </Checkbox.Group>
          </>
        ) : (
          <NoFilters>
            {t("opportunity:candidates.strictFilters.noFiltersSet")}
          </NoFilters>
        )}
        {/* <Link to={link} data-test="strict-filters-link">
        <Button
          icon="edit"
          ghost
          size="small"
          onClick={() =>
            gtag.event({
              category: "VacancyCandidates",
              action: `filterExcluding-Edit`
            })
          }
          style={{
            color: "#747c84",
            fontSize: 12,
            marginLeft: "-8px"
          }}
          type="link"
        >
          {t("opportunity:candidates.strictFilters.editOpportunity")}
        </Button>
      </Link> */}
      </Container>
    </details>
  );
};

export default StrictFilters;
